module.exports = __webpack_public_path__ + "img/pending_payment.ca0aaddc.png";